import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getListPolinomyTypes = () => {
    return axios.get(`/api/Partida/polinomyType/list`, { headers: authHeaderJson() } )
};

const getPolinomyTypeById = (polinomyTypeId) => {
        return axios.get(`/api/Partida/polinomyType/${polinomyTypeId}`, { headers: authHeaderJson() } );
};

const addPolinomyType = (polinomyType) => {
    return axios.post(`/api/Partida/polinomyType/add/`, polinomyType, { headers: authHeaderJson() } );
}

const addPolinomyTypeList = (polinomyTypes) => {
    return axios.post(`/api/Partida/polinomyType/add/list`, polinomyTypes, { headers: authHeaderJson() } );
}

const savePolinomyTypeById = (polinomyTypeId, objContract) => {
    return axios.put(`/api/Partida/polinomyType/${polinomyTypeId}`, objContract, { headers: authHeaderJson() });
};

const deletePolinomyType = (polinomyTypeId) => {
    return axios.delete(`/api/Partida/polinomyType/${polinomyTypeId}`, { headers: authHeaderJson() });
}

export {
    getListPolinomyTypes,
    getPolinomyTypeById,
    addPolinomyType,
    addPolinomyTypeList,
    savePolinomyTypeById,
    deletePolinomyType
}